import ProductInterface from '../ProductInterface';
import MeteogrfOptions from './MeteogrfOptions';
import { processMeteogrf } from './meteogrfProcess';

export default function Meteogrf() {
  return (
      <ProductInterface
          product = "meteogrf"
          ProductOptions = {MeteogrfOptions}
          processProduct = {processMeteogrf}
      />
  )
} 